/* global console, jsPanel, routie */

/*
if (location.host === 'jspanel.de.localhost') {
    jQuery.jsPanel.defaults.dragit.disableui = true;
    jQuery.jsPanel.defaults.resizeit.disableui = true;
}
*/


function scrollToItem(item) {
    var top = jQuery(item).offset().top - 60;
    jQuery(document).scrollTop(top);
}

jQuery('#scriptversion').text(jsPanel.version + ' ' + jsPanel.date);

if (jQuery) { console.info('jQuery version: ' + jQuery.fn.jquery); }
if (jQuery.ui) { console.info('jQuery UI version: ' + jQuery.ui.version); }
if (jsPanel) {console.info('jsPanel version: ' + jsPanel.version + ' ' + jsPanel.date);}


routie({
    '':                     function () {
        jQuery('#page-wrapper').empty().load('../media/files/gettingstarted.html');
        jQuery(window).scrollTop(0);
    },
    'gettingstarted':       function () {
        jQuery('#page-wrapper').empty().load('../media/files/gettingstarted.html');
        jQuery(window).scrollTop(0);
    },
    'download':             function () {
        jQuery('#page-wrapper').empty().load('../media/files/download.html');
        jQuery(window).scrollTop(0);
    },
    'jspanelfunction':      function () {
        jQuery('#page-wrapper').empty().load('../media/files/api/jspanelfunction.html');
        jQuery(window).scrollTop(0);
    },
    'option/:option':       function (option) {
        jQuery('#page-wrapper').empty().load('../media/files/api/o-' + option + '.html');
        jQuery(window).scrollTop(0);
    },
    'method/:method':       function (method) {
        jQuery('#page-wrapper').empty().load('../media/files/api/m-' + method + '.html');
        jQuery(window).scrollTop(0);
    },
    'property/:property':   function (property) {
        jQuery('#page-wrapper').empty().load('../media/files/api/p-' + property + '.html');
        jQuery(window).scrollTop(0);
    },
    'event':                function () {
        jQuery('#page-wrapper').empty().load('../media/files/api/e-overview.html');
        jQuery(window).scrollTop(0);
    },
    'event/*':              function () {
        jQuery('#page-wrapper').empty().load('../media/files/api/e-overview.html');
        jQuery(window).scrollTop(0);
    },
    'defaults':             function () {
        jQuery('#page-wrapper').empty().load('../media/files/api/defaults.html');
        jQuery(window).scrollTop(0);
    },
    'examples':             function () {
        jQuery('#page-wrapper').empty().load('../media/files/examples.html');
        jQuery(window).scrollTop(0);
    },
    'examples/:item':       function (item) {
        jQuery('#page-wrapper').empty().load('../media/files/' + item + '.html');
        jQuery(window).scrollTop(0);
    },
    'mailinglist':          function () {
        jQuery('#page-wrapper').empty().load('../media/files/mailinglist.html');
        jQuery(window).scrollTop(0);
    },
    'faq':                  function () {
        jQuery('#page-wrapper').empty().load('../media/files/faq.html');
        jQuery(window).scrollTop(0);
    },
    'global':               function () {
        jQuery('#page-wrapper').empty().load('../media/files/globalobjectjspanel.html');
        jQuery(window).scrollTop(0);
    },
    'global/export-layout': function () {
        jQuery('#page-wrapper').empty().load('../media/files/export-layout.html');
        jQuery(window).scrollTop(0);
    },
    'global/:item':         function (item) {
        item = '#jsPanel-' + item;
        jQuery('#page-wrapper').empty().load('../media/files/globalobjectjspanel.html', function () {
            scrollToItem(item);
        });
    },
    '*':                    function () {
        jQuery('#page-wrapper').empty().load('../media/files/gettingstarted.html');
        jQuery(window).scrollTop(0);
    }

});

jQuery('#changelog').on('click', function (e) {
    e.preventDefault();
    jQuery.jsPanel({
        contentSize:     {width: 800, height: window.innerHeight * 0.9},
        contentOverflow: {vertical: 'scroll'},
        contentAjax:     {
            url:      '../media/files/CHANGELOG.md',
            method:   'GET',
            dataType: 'text',
            done:     function (data, textStatus, jqXHR, panel) {
                var converter = new showdown.Converter();
                var html = converter.makeHtml(data);
                panel.content.css({padding: '20px'}).empty().append(html);
            }
        },
        theme:           'tan',
        headerTitle:     'jsPanel Changelog'
    });
});
jQuery('#newsletter').on('click', function (e) {
    e.preventDefault();
    jQuery.jsPanel({
        contentAjax: {
            url: "../media/files/mailchimp.html",
            autoload: true
        },
        contentSize: "600 387",
        headerTitle: "jsPanel newsletter signup",
        headerControls: {
            controls: "closeonly"
        },
        theme: "crimson"
    });
});




jQuery(document).on('jspanelloaded', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
    console.info('jsPanel.activePanels = ', jsPanel.activePanels.list);
});
jQuery(document).on('jspanelstatuschange', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelbeforeclose', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelclosed', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
    console.info('jsPanel.activePanels = ', jsPanel.activePanels.list);
});
jQuery(document).on('jspanelbeforemaximize', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelmaximized', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelbeforenormalize', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelnormalized', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelbeforeminimize', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelbeforesmallify', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelbeforeunsmallify', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelminimized', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelsmallified', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelsmallifiedmax', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelfronted', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});
jQuery(document).on('jspanelunsmallified', function(e, id) {
    console.info('Event: ' + e.type + ' for ID: ' + id);
});


